module.exports = __webpack_public_path__ + "static/img/OIP2.c2f582d.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cashWheel/OIP2.webp
// module id = YPl4
// module chunks = 0